/* Built In Imports */

/* External Imports */
import { Box, Link } from '@chakra-ui/react';
import { useMediaQuery } from 'react-responsive';
import NextLink from 'next/link';

/* Internal Imports */
/* Components */
import LazyImageRenderComponent from '@components/UI/LazyImageRenderComponent';
import { refineUrlDomain } from '@components/Utility/utils';

/**
 * Renders the ImageBannerAd Card component
 *
 * @param sectionContent.sectionContent
 * @param {object} sectionContent - Data for section
 * @param {string} region - Region for page
 * @param {Sting} lang - Language for page
 * @param sectionContent.region
 * @param sectionContent.lang
 * @param sectionContent.width
 * @param sectionContent.height
 * @param sectionContent.my
 * @param sectionContent.display
 * @param sectionContent.maxW
 * @returns {ReactElement} ImageBannerAd component
 */
const ImageBannerAdWOB = ({ sectionContent, region, lang, addTopSpace = false }) => {
  const isTabScreen = useMediaQuery({ maxWidth: 767 });
  const isWebScreen = useMediaQuery({ maxWidth: 1024 });

  const getImage = () => {
    return (
      <LazyImageRenderComponent
        alt={sectionContent?.image?.title}
        title={sectionContent?.image?.title}
        textAlign="center"
        src={
          isTabScreen
            ? sectionContent?.mobileImage?.url ||
              sectionContent?.tabletImage?.url ||
              sectionContent?.image?.url
            : isWebScreen
            ? sectionContent?.tabletImage?.url || sectionContent?.image?.url
            : sectionContent?.image?.url
        }
        w={'100%'}
        h="100%"
      />
    );
  };
  return (
    <Box
      textAlign="center"
      position="relative"
      pt={{ base: '36px', md: '0', lg: addTopSpace ? '100px' : '0' }}
      mb={{ base: '22px', md: '0px' }}
      px={{ base: '16px', md: '0px' }}
      mx="0px"
      width={'100%'}
      height={'100%'}
      lineHeight="0px"
    >
      {sectionContent?.linkUrl ? (
        <NextLink
          href={
            sectionContent?.linkUrl
              ? refineUrlDomain(sectionContent?.linkUrl, region, lang)
              : 'javascript:;'
          }
          passHref
          legacyBehavior
        >
          <Link
            target={
              sectionContent?.linkUrl?.indexOf('http') > -1 ? '_blank' : ''
            }
          >
            {getImage()}
          </Link>
        </NextLink>
      ) : (
        getImage()
      )}
    </Box>
  );
};

export default ImageBannerAdWOB;
